import React from "react";
import { PAGE_SIZE, ORIENTATION } from "./constants/appConstants";
import { parseSync } from 'svgson';
import { updateSvgValues } from "./svgUtils";
import { Icon, message } from 'antd';
import { CONTEXT_KEYS } from '../context/complexArtboardContext';
import { CREATIVE_BLOCK, dummyCallback, DYNAMIC_TABLE_BLOCK, FOOTER, HEADER, PrintingModal, TABLE_OF_CONTENTS } from "./complexDocumentConstants";
import { COMPLEX_PAGE_OPTIONS } from '../containers/ComplexDocumentDesign/translationValues';
import { Quill } from "react-quill";
import { DOCUMENT_PANEL, STATUS_MONITORING } from "../containers/Dashboard/StatusMonitoring/TranslationValues";
import { DeniedSVGIcon, HourGlassIcon, TickSVG, RejectionSVG } from "../images/svgIcons";
import { IconWrapper } from "../containers/Dashboard/StatusMonitoring/Styles";
import moment from 'moment';
import { emailFunnelChartLabels, metaSearchKeyMappings } from "./constants/statusMonitoring";
import { deepCopy } from "./javascript";
import { COMPLEX_DOCUMENT_CONTEXT_KEYS } from "../context/complexDocumentContext";
import { checkCommunName, getTocFlow } from "./services/complexDocumentsAPI";
import { EMAIL_DASHBOARD } from "../containers/Dashboard/TranslationValues";
import { getComplexDocumentStatus } from "./services/complexDocumentsAPI";
import { VERSION_CONTEXT_KEYS } from "../context/complexVersionContext";
import { getComplexEmailStatus } from "./services/complexEmailAPI";
import { COMPLEX_DOCUMENT_VERSION } from "./complexDocumentConstants";
import { VARIABLE_TYPE } from "./constants/appConstants";
import Papa from "papaparse";
import * as XLSX from 'xlsx';
import { jsonToFile, xmlToFile, toZipFile } from "./javascript";
import { dynamicTableHasMoreThanTwoLevels } from "../containers/ComplexDocumentDesign/complexDocumentHelper";
import { checkFileFormat, getPayloadFromFile, getXMLFromJSON } from "./transactionHelpers";
import { uploadDataSetTransaction, staticDownload } from "./services/documentAPI";
import { PDF_TRANSACTIONS, TRANSACTIONS } from "../containers/TemplateSection/translationValues";
import { uploadComplexEmailDataSet } from "./services/complexEmailAPI";
import { uploadEnvDataSet } from "./services/documentAPI";
import { CHANNEL_SIDEBAR_TAB as trans } from "../containers/ComplexDocumentDesign/ChannelTab/translationValues";
import { processFile } from "./transactionHelpers";
import { envs } from "./complexDocumentConstants";

export const Clipboard = Quill.import('modules/clipboard');
const WEBSOCKET_URL = process.env.REACT_APP_SERVER_URL.replaceAll('http://', 'ws://').replaceAll('https://', 'wss://');
export default {
  BASE_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_BACKEND+'/'}`,
  DESIGN_SYSTEM_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_DESIGN_SYSTEM+'/'}`,
  TRANSACTION_SYSTEM_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_TRANSACTIONS_SYSTEM+'/'}`,
  BATCH_SYSTEM_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_BATCH_SYSTEM+'/'}`,
  // BATCH_SYSTEM_URL: `${process.env.REACT_APP_SERVER_URL+'/batch/'}`,
  TRACKING_SYSTEM_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_TRACKING_SYSTEM+'/'}`,
  // TRACKING_SYSTEM_URL: `${process.env.REACT_APP_SERVER_URL+'/tracking/'}`,
  DOWNLOAD_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_BACKEND+'/generatedpdf/'}`,
  EML_DOWNLOAD_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_BACKEND+'/'}`,
  AUTH_BASE_URL: `${process.env.REACT_APP_SERVER_URL || ''}`,
  AUTH_BASE_PATH: `${process.env.REACT_APP_AUTH || ''}`,
  AUTH_SERVICE_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_AUTH+'/'}`,
  SSO_SERVICE_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_BACKEND+'/sso/'}`,
  GOOGLE_FONTS: `https://www.googleapis.com/webfonts/v1/webfonts?key=${process.env.REACT_APP_GOOGLE_FONTS_TOKEN}`,
  IMAGE_GENERATOR_URL: `${process.env.REACT_APP_IMAGE_GENERATOR_URL}`,
  DEPLOYMENT_URL: `${process.env.REACT_APP_FRONTEND}`,
  SERVER_URL: process.env.REACT_APP_SERVER_URL,
  APOLLO_HTTP_URL: `${process.env.REACT_APP_SERVER_URL+process.env.REACT_APP_TRACKING_SYSTEM+'/graphiql?path=/tracking/graphql&wsPath=/tracking/graphql'}`,
  APOLLO_SOCKET_URL: `${WEBSOCKET_URL+process.env.REACT_APP_TRACKING_SYSTEM+'/graphql'}`,
  // KUBE_URL:`https://kubedev03.tekclansolutions.com:3443`
  // SUPERTOKENS_BASE_URL: `${process.env.SUPERTOKENS_URL}`
  FRONTEND_URL: process.env.REACT_APP_SERVER_URL,
  EMBED_AUTHENTICATE_URL: `${process.env.REACT_APP_SERVER_URL + '/pds/client'}`
};

export const SUPPORT_EMAIL_ID = 'support@perfectdoc.studio';
export const IS_WHATSAPP_ENABLED = false;

export const ENABLE_INSPIRATIONS = false;
export const OPENREPLAY_DISABLE_SECURE_MODE = process.env.REACT_APP_OPENREPLAY_SECURE_MODE === 'true';
export const ENTERPRISE_ENV = process.env.REACT_APP_DEPLOYMENT_TYPE === 'enterprise';
// export const AZURE_DEPLOYMENT = process.env.REACT_APP_DEPLOYMENT_ENV === 'azure';
export const AZURE_DEPLOYMENT = true; // After supertokens was replaced by backend, this is the current default setting
export const ENABLE_EMAIL_DESIGNS = ENTERPRISE_ENV || process.env.REACT_APP_ENABLE_EMAIL_REVAMP === 'true'; // temporarily disabled the email design system in the SaaS environment
console.log("process.env.REACT_APP_ENABLE_EMAIL_REVAMP :: ", process.env.REACT_APP_ENABLE_EMAIL_REVAMP);
export const EMAIL_REVAMP = process.env.REACT_APP_ENABLE_EMAIL_REVAMP === 'true';
export const DEFAULT_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const READABLE_DATE_TIME_FORMAT = 'lll';
export const ENABLE_TOLGEE = process.env.REACT_APP_TOLGEE_ENABLE === 'true';
export const PDF_DOWNLOAD_PRICE_USD = 1;
export const APP_VERSION = process.env.REACT_APP_VERSION;
export const SSO_REDIRECT_URL = `${process.env.REACT_APP_SERVER_URL}/redirect`;
// export const SSO_REDIRECT_URL = 'http://localhost:7000/redirect';

export const TERMS_AND_CONDITIONS_URL = 'https://perfectdoc.studio/policies.html';
export const GO_CREATE_UI_DESIGN = process.env.REACT_APP_GO_CREATE_UI_DESIGN === 'true';

const LANGUAGE_MAPPING = {
  'en': 'Open Sans',
  'en-GB': 'Open Sans',
  'en-US': 'Open Sans',
  'es-US': 'Open Sans',
  'fr': 'Open Sans',
  'pt': 'Open Sans',
  'ja': 'Noto Sans JP',
  'ar': 'Noto Sans Arabic'
}

export const DEFAULT_FONT_FOR_LOCALISED_LANGUAGES = (lang) => {
  return LANGUAGE_MAPPING[lang] || 'Open Sans';
}

export const PASSWORD_MAX_LENGTH = 30;
export const EMAIL_MAX_LENGTH = 100;

export const getWidthHeightScale = ({value, orientation, size, dimension, isDndFlow, isDocToMail, isPreviewModal, isActModal, actualScaling, scaling, rulerWidthAdjuster}) => {
  const reduceScaleValue =
    dimension === 'width'
      ? orientation === ORIENTATION.LANDSCAPE
        ? PAGE_SIZE.US_LEGAL_LANDSCAPE_WIDTH
        : PAGE_SIZE.US_LEGAL_LANDSCAPE_HEIGHT
      : dimension === 'height' && orientation === ORIENTATION.LANDSCAPE
      ? PAGE_SIZE.US_LEGAL_LANDSCAPE_HEIGHT
      : PAGE_SIZE.US_LEGAL_LANDSCAPE_WIDTH;

  let element;
  let usLandscape;
  let a4Landscape;
  
  if(isDndFlow || isDocToMail) {
    element = document.getElementsByClassName('showSideBar')[0];
    usLandscape =0.2;
    a4Landscape = 0.25;
  }
  if(isPreviewModal) {
    element = document.getElementsByClassName('previewModalView')[0];
    usLandscape = 0.5;
    a4Landscape = 0.55
  }
  if(isActModal){
    element = document.getElementsByClassName('actModalView')[0];
    usLandscape = 0.8;
    a4Landscape = 0.85;
  }

  if (isDndFlow || isDocToMail || isPreviewModal) {
    if (size !== PAGE_SIZE.CUSTOM) {
      actualScaling = orientation === ORIENTATION.LANDSCAPE ? ((size === PAGE_SIZE.US_LEGAL || size === PAGE_SIZE.US_LETTER) ? usLandscape : a4Landscape) : scaling;
    } else if (size === PAGE_SIZE.CUSTOM && value > reduceScaleValue) {
      if(dimension === 'width'){
      actualScaling = (isDndFlow||isDocToMail) ? Math.floor(((element.offsetWidth) / value )*100)/100 : isPreviewModal? Math.floor((element.offsetWidth / value )*10)/10 : scaling
      } else {
        return {updatedScaling: actualScaling, widthHeightValue:`${actualScaling * value + rulerWidthAdjuster}px` }
      }
    } else {
      actualScaling = size === PAGE_SIZE.CUSTOM ? (orientation === ORIENTATION.LANDSCAPE ? a4Landscape : usLandscape) : scaling;
    }
  }
  
  return {updatedScaling: actualScaling, widthHeightValue:`${actualScaling * value + rulerWidthAdjuster}px` }
};

const getBlockdtoListFromDocumentContext = (blockDetails, documentContext) => {
  if (blockDetails?.blockDTOList) {
    return blockDetails.blockDTOList;
  }
  if (!documentContext) {
    return [];
  }
  const block = documentContext[blockDetails.uuid];
  const tableProperties = block.style.tableProperties;
  const childBlocks = [];
  if (tableProperties.topBlock) {
    childBlocks.push(documentContext[tableProperties.topBlock]);
  }
  if (tableProperties.bottomBlock) {
    childBlocks.push(documentContext[tableProperties.bottomBlock]);
  }
  return childBlocks;
};

export const autoTransform = (
  blocks,
  existingFlow = { width: 794, height: 1123, fontSize: 16 },
  width = 794,
  height = 1123,
  isCreateEmailFromDocument = false,
  documentContext
) => {
  const widthScalingFactor = existingFlow.width / width;
  const heightScalingFactor = existingFlow.height / height;
  const widthLessThanHeight = widthScalingFactor < heightScalingFactor;
  const fontScalingFactor = widthLessThanHeight
    ? Math.min(widthScalingFactor, heightScalingFactor)
    : Math.max(widthScalingFactor, heightScalingFactor);
  for (let i = 0; i < blocks.length; i++) {
    const singleBlock = blocks[i];
    if (singleBlock.blockType === 'creative' || singleBlock.blockType === DYNAMIC_TABLE_BLOCK) {
      const block_dto =
        singleBlock.blockType === DYNAMIC_TABLE_BLOCK ? getBlockdtoListFromDocumentContext(singleBlock, documentContext) : [singleBlock];
      for (let j = 0; j < block_dto.length; j++) {
        const block = block_dto[j];
        if (block.style) {
          if (block.style.height) {
            const creativeBlockHeight = Math.round(block.style.height * widthScalingFactor);
            block.style.height = creativeBlockHeight;
          }
          if (block.style.fontSize) {
            block.style.fontSize = parseFloat((block.style.fontSize * fontScalingFactor).toFixed(2));
          }
        }
        if (block.contents) {
          block.contents.forEach(async content => {
            if (content.style && content.style.width) {
              content.style.width = Math.round(content.style.width * widthScalingFactor);
            }
            if (content.style && content.style.height) {
              content.style.height = Math.round(content.style.height * widthScalingFactor);
            }

            if (content.style && content.style.x) {
              content.style.x = Math.round(content.style.x * widthScalingFactor);
            }
            if (content.style && content.style.y) {
              content.style.y = Math.round(content.style.y * widthScalingFactor);
            }

            if (content.contents && content.contentType !== 'chart') {
              content.contents.forEach(innerContent => {
                if (innerContent.style) {
                  if (innerContent.style.fontSize) {
                    innerContent.style.fontSize = parseFloat(
                      (innerContent.style.fontSize * fontScalingFactor).toFixed(2)
                    );
                  } else if (isCreateEmailFromDocument && !innerContent.style.fontSize) {
                    innerContent.style.fontSize = parseFloat(
                      (existingFlow.fontSize * fontScalingFactor).toFixed(2)
                    );
                  }
                }
              });
            }

            if (content.contentType === 'svg') {
              const parsedJSON = parseSync(content.url);
              const updatedSVGDetails = {
                width: content.style.width,
                height: content.style.height,
                x: content.style.x,
                y: content.style.y,
                rotate: content.style.rotate,
                svgElement: true,
              };
              const { stringSVG } = updateSvgValues(
                updatedSVGDetails,
                {
                  elementDetails: {
                    style: {},
                    value: {
                      ...parsedJSON,
                      url: '',
                    },
                    uiType: content.uiType,
                  },
                },
                'style',
              );
              content.url = stringSVG;
            }
          });
        }
      }
    }
  }
  return { isTransformed: true, updatedBlocks: blocks };
};

export const block_Selection = ({
  selectedBlocks,
  itemUUID,
  parentUUID,
  flowDetails,
  selectedBlocksParent,
  isHeaderOrFooterSelected,
  isContentSelected,
  updateArtboard,
  methods,
  t
}) => {
  const selectedBlock = flowDetails[`${parentUUID}-0`].indexOf(itemUUID);
  const firstBlockIndex = selectedBlocks[0]
    ? flowDetails[`${parentUUID}-0`].indexOf(selectedBlocks[0])
    : 0;
  const lastBlockIndex = selectedBlocks[selectedBlocks.length - 1]
    ? flowDetails[`${parentUUID}-0`].indexOf(selectedBlocks[selectedBlocks.length - 1])
    : 0;
  const selectedBlockIsHeaderOrFooter =
    flowDetails.header === itemUUID || flowDetails.footer === itemUUID;
  const selectedBlockIsContent = flowDetails[`${parentUUID}-0`].includes(itemUUID);
  if (!selectedBlocksParent || selectedBlocksParent === parentUUID) {
    if (selectedBlocks.includes(itemUUID)) {
      const removeBlockIndex = selectedBlocks.indexOf(itemUUID);
      if (removeBlockIndex === 0 || removeBlockIndex === selectedBlocks.length - 1) {
        selectedBlocks = selectedBlocks.filter(item => item !== itemUUID);
      } else {
        message.warning(t(COMPLEX_PAGE_OPTIONS.BLOCK_UNSELECT_WARNING.key, COMPLEX_PAGE_OPTIONS.BLOCK_UNSELECT_WARNING.value));
        return;
      }

      if (isHeaderOrFooterSelected && selectedBlockIsHeaderOrFooter) {
        isHeaderOrFooterSelected = false;
      }
      if (isContentSelected && selectedBlockIsContent) {
        isContentSelected = false;
      }
    } else {
      if (
        (isHeaderOrFooterSelected && selectedBlockIsContent) ||
        (isHeaderOrFooterSelected && selectedBlockIsHeaderOrFooter)
      ) {
        message.warning(t(COMPLEX_PAGE_OPTIONS.HEADER_FOOTER_SELECTED_WARNING.key, COMPLEX_PAGE_OPTIONS.HEADER_FOOTER_SELECTED_WARNING.value, { blockType: flowDetails.header === selectedBlocks[0] ? 'Header' : 'Footer' }));
        return;
      }
      if (isContentSelected && selectedBlockIsHeaderOrFooter) {
        message.warning(t(COMPLEX_PAGE_OPTIONS.CONTENT_SELECTED_WARNING.key, COMPLEX_PAGE_OPTIONS.CONTENT_SELECTED_WARNING.value));
        return;
      }

      if (
        firstBlockIndex - 1 === selectedBlock ||
        lastBlockIndex + 1 === selectedBlock ||
        selectedBlocks.length === 0
      ) {
        const _block = methods.get()[itemUUID];
        if ((_block.type === HEADER || _block.type === FOOTER) && _block.isStandalone) {
          updateArtboard({[CONTEXT_KEYS.STANDALONE_BLOCK_EDIT]: _block.uuid});
          // message.warning(t(COMPLEX_PAGE_OPTIONS.HEADER_FOOTER_REFERENCED_WARNING.key, COMPLEX_PAGE_OPTIONS.HEADER_FOOTER_REFERENCED_WARNING.value, { blockType: _block.type}));
          return;
        }
        if (_block.type === HEADER || _block.type === FOOTER) {
          isHeaderOrFooterSelected = true;
        } else {
          isContentSelected = true;
        }
        selectedBlocks =
          firstBlockIndex - 1 === selectedBlock
            ? [itemUUID, ...selectedBlocks]
            : lastBlockIndex + 1 === selectedBlock
            ? [...selectedBlocks, itemUUID]
            : [...selectedBlocks, itemUUID];
      } else {
        message.warning(t(COMPLEX_PAGE_OPTIONS.BLOCK_SELECTION_SEQUENCE_WARNING.key, COMPLEX_PAGE_OPTIONS.BLOCK_SELECTION_SEQUENCE_WARNING.value));
        return;
      }
    }

    updateArtboard({
      [CONTEXT_KEYS.HEADER_OR_FOOTER_BLOCK_SELECTED]: isHeaderOrFooterSelected,
      [CONTEXT_KEYS.CONTENT_BLOCK_SELECTED]: isContentSelected,
      [CONTEXT_KEYS.SELECTED_BLOCKS]: selectedBlocks,
      [CONTEXT_KEYS.SELECTED_BLOCKS_PARENT]: selectedBlocks.length > 0 ? parentUUID : '',
    });
  }
};

export const checkSessionUserAccess = (userDetails, userType, roles) => {
  if (roles) {
    return (
      userDetails?.userType === userType && userDetails.roles.some(role => roles.includes(role))
    );
  } else {
    return userDetails?.userType === userType;
  }
};

export const checkUserAccessRoles = (userDetails, roles) => {
  return userDetails?.roles?.some(role => roles.includes(role));
};

export const getClipboardData = async () => {
  let copiedElements;
  try {
    const elements = await navigator.clipboard.readText();
    copiedElements = JSON.parse(elements);
  } catch (err) {
    console.error('Failed to read clipboard contents: ', err);
    copiedElements = { pdsCopiedElements: [] }; // Set to null or some default value in case of an error
  }
  return copiedElements;
};

export const resetClipboardData = async () => {
  try {
    await navigator.clipboard.writeText('');
  } catch (err) {
    console.error('Failed to clear clipboard contents: ', err);
  }
};

export const EXISTING_CHANNELS = ENTERPRISE_ENV ? [
   {
     key: 'document',
     translateKey: 'DOCUMENT'
   },
   {
     key: 'email',
     translateKey: 'EMAIL'
   },
   {
     key: 'short_message',
     translateKey: 'SHORT_MESSAGE'
   }
 ] : [
   {
     key: 'document',
     translateKey: 'DOCUMENT'
   },
   {
     key: 'email',
     translateKey: 'EMAIL'
   },
 ];

 export const getTemplateVersion = version => {
   return version === 0 ? 'published' : version === 1 ? 'testing' : 'draft';
 };

 const statusLabelMap = {
   success: 'SUCCESS',
   sent: 'SENT',
   bounced:'BOUNCED',
   delivered: 'DELIVERED',
   opened: 'OPENED',
   clicked : 'CLICKED',
   failure: 'FAILURE',
   inprogress: 'IN_PROGRESS',
   in_progress: 'IN_PROGRESS',
   yet_to_start: 'YET_TO_START',
   processing_complete: 'PROCESSING_COMPLETE',
   waiting_for_approval_level_1: 'WAITING_FOR_APPROVAL_LEVEL_1',
   approved_by_level_1: 'APPROVED_BY_LEVEL_1',
   waiting_for_approval_level_2: 'WAITING_FOR_APPROVAL_LEVEL_2',
   approved_by_level_2: 'APPROVED_BY_LEVEL_2',
   waiting_for_approval_level_3: 'WAITING_FOR_APPROVAL_LEVEL_3',
   approved_by_level_3: 'APPROVED_BY_LEVEL_3',
   waiting_for_approval_level_4: 'WAITING_FOR_APPROVAL_LEVEL_4',
   approved_by_level_4: 'APPROVED_BY_LEVEL_4',
   ready_to_print: 'READY_TO_PRINT_FILTER',
   sent_for_printing: 'DISPATCH_INITIATED',
   printing_complete: 'PRINTING_COMPLETE',
   reject_by_level_1: 'REJECT_BY_LEVEL_1',
   reject_by_level_2: 'REJECT_BY_LEVEL_2',
   reject_by_level_3: 'REJECT_BY_LEVEL_3',
   reject_by_level_4: 'REJECT_BY_LEVEL_4',
   no_approver_found: 'NO_APPROVER_FOUND_FILTER',
   yet_to_print: 'YET_TO_PRINT',
   print_in_queue: 'PRINT_IN_QUEUE',
   print_completed: 'PRINT_COMPLETED',
   draft: 'DRAFT',
   STARTED: 'STARTED',
   waiting_for_approval: 'WAITING_FOR_APPROVAL',
   approved: 'APPROVED',
   rejected: 'REJECTED',
   SPLIT_COMPLETED: 'SPLIT_COMPLETED',
   SUBMITTED_PDF_GENERATION_COMPLETED: 'SUBMITTED_PDF_GENERATION_COMPLETED',
   reject: 'REJECT',
   SCHEDULED: 'SCHEDULED',
   ORIGINAL_STORED: 'ORIGINAL_STORED',
   PARTIALLY_RELEASED: 'PARTIALLY_RELEASED',
   RELEASED: 'RELEASED',
   WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
   LETTERS_GENERATION_STARTED: 'LETTERS_GENERATION_STARTED',
   LETTERS_GENERATED: 'LETTERS_GENERATED',
   HOLD:'HOLD',
   GENERATED: 'GENERATED',
   generated: 'GENERATED',
   GENERATION_NOT_STARTED: 'GENERATION_NOT_STARTED',
   SPLIT_STARTED: 'SPLIT_STARTED',
   MAIN_FILE_UPLOADING: 'MAIN_FILE_UPLOADING',
   CANCELLED: 'CANCELLED',
   ABORTED: 'ABORTED',
   SELECTED_RELEASED:'SELECTED_RELEASED',
   ready_for_delivery: 'READY_FOR_DELIVERY',
 };

 const statusColorMap = {
   in_progress: '#3FB8D5',
   yet_to_start: '#C9C8CC',
   processing_complete: '#C8E066',
   success: '#C8E066',
   bounced: '#3FB8D5',
   sent: '#C8E066',
   delivered: '#99B3F0',
   opened: '#D6E1FA',
   clicked : '#1B3074',
   ready_to_print: '#AC9BFB',
   sent_for_printing: '#1fa270',
   failure: '#35346A',
   printing_complete: '#FCE83A',
   inprogress: '#6CE5E8',
   waiting_for_approval_level_1: '#232360',
   waiting_for_approval_level_2: '#232360',
   waiting_for_approval_level_3: '#232360',
   waiting_for_approval_level_4: '#232360',
   approved_by_level_1: '#AC9BFB',
   approved_by_level_2: '#AC9BFB',
   approved_by_level_3: '#AC9BFB',
   approved_by_level_4: '#AC9BFB',
   reject_by_level_1: '#D72D6C',
   reject_by_level_2: '#D72D6C',
   reject_by_level_3: '#D72D6C',
   reject_by_level_4: '#D72D6C',
   no_approver_found: '#6F08EE',
   yet_to_print: '#232360',
   print_in_queue: '#6CE5E8',
   print_completed: '#C8E066',
   draft: '#FCB5B5',
   started: '#A7C957',
   waiting_for_approval: '#CAFE48',
   approved: '#7CB4B8',
   rejected: '#FF5C5C',
   SPLIT_COMPLETED: '#70F8BA',
   SUBMITTED_PDF_GENERATION_COMPLETED: '#CBBF7A',
   reject: '#FF5C5C',
   SCHEDULED: '#42BFDD',
   ORIGINAL_STORED: '#A6C36F',
   PARTIALLY_RELEASED: '#E4959E',
   WAITING_FOR_APPROVAL: '#CAFE48',
   HOLD:'#6CE5E8',
   GENERATED: '#C8E066',
   generated: '#C8E066',
   LETTERS_GENERATED: '#C8E066',
   LETTERS_GENERATION_STARTED: '#f2f0b0',
   GENERATION_NOT_STARTED: '#a005ec40',
   SPLIT_STARTED: '#7c6eda',
   MAIN_FILE_UPLOADING: '#42BFDD',
   RELEASED: '#C8E066',
   CANCELLED: '#FF5C5C',
   ABORTED: '#f45c5c',
   SELECTED_RELEASED: '#C8E066',
   ready_for_delivery: '#40a9ff',
 };

 export const doesBatchHaveDocuments = (batchDetails) => {
   return batchDetails.batchStats.filter(batch => batch.channel === 'print').length > 0;
 }

 export const getStatusMessage = (status, t) => {
   // Check if status exists in the map
   if (statusLabelMap[status]) {
     const key = statusLabelMap[status];
     return t(STATUS_MONITORING[key].key, STATUS_MONITORING[key].value);
   }
   return '';
 };

 export const getStatusColor = status => {
   if (statusColorMap[status]) {
     return statusColorMap[status];
   }
   return '';
 };

 export const getStatusIcon = caseStatus => {
   switch (caseStatus) {
     case 'in_progress':
       return (
         <IconWrapper background={'#a123a3'}>
           <HourGlassIcon />
         </IconWrapper>
       );
     case 'yet_to_start':
       return (
         <IconWrapper background={'#a123a3'}>
           <HourGlassIcon />
         </IconWrapper>
       );
     case 'processing_complete':
       return (
         <IconWrapper background={'#c8e066'}>
           <TickSVG />
         </IconWrapper>
       );
     case 'waiting_for_approval_level_1':
     case 'waiting_for_approval_level_2':
     case 'waiting_for_approval_level_3':
     case 'waiting_for_approval_level_4':
       return (
         <IconWrapper background={'#a123a3'}>
           <HourGlassIcon />
         </IconWrapper>
       );
     case 'approved_by_level_1':
     case 'approved_by_level_2':
     case 'approved_by_level_3':
     case 'approved_by_level_4':
       return (
         <IconWrapper background={'#c8e066'}>
           <TickSVG />
         </IconWrapper>
       );
      case 'ready_to_print':
        return (
          <IconWrapper background={'#c8e066'}>
            <TickSVG />
          </IconWrapper>
        );
     case 'sent_for_printing':
       return (
         <IconWrapper background={'#a123a3'}>
           <HourGlassIcon />
         </IconWrapper>
       );
     case 'printing_complete':
       return (
         <IconWrapper background={'#c8e066'}>
           <TickSVG />
         </IconWrapper>
       ); // Printer
     case 'reject_by_level_1':
     case 'reject_by_level_2':
     case 'reject_by_level_3':
     case 'reject_by_level_4':
      case 'reject':
       return (
           <RejectionSVG />
       );
     case 'draft':
       return (
        <IconWrapper background={'#f3e8ff'}>
           <Icon type="edit" />
         </IconWrapper>
       )
     default:
       return null;
   }
 };

 export const isShortMessageEnabled = false;

 export const getChannelTotals = (data, localize, t, processedCount = false) => {
   const totals = data.reduce(
     (acc, item) => {
       const count = processedCount
         ? Number(item.successCount || 0) + Number(item.failureCount || 0)
         : Number(item.totalCount || 0);
       acc[item.channel] = (acc[item.channel] || 0) + count;
       return acc;
     },
     { print: 0, email: 0, hybrid: 0, ...( isShortMessageEnabled && { message: 0 }) }
   );

   if (localize) {
     const localizedKeys = {
       print: t(STATUS_MONITORING.CHART_PRINT_LABEL.key, STATUS_MONITORING.CHART_PRINT_LABEL.value),
       email: t(STATUS_MONITORING.CHART_EMAIL_LABEL.key, STATUS_MONITORING.CHART_EMAIL_LABEL.value),
       sms: t(STATUS_MONITORING.CHART_SMS_LABEL.key, STATUS_MONITORING.CHART_SMS_LABEL.value),
       message : t(
        STATUS_MONITORING.CHART_MESSAGES_LABEL.key,
        STATUS_MONITORING.CHART_MESSAGES_LABEL.value,
      ),
       voice: t(STATUS_MONITORING.CHART_VOICE_LABEL.key, STATUS_MONITORING.CHART_VOICE_LABEL.value),
       whatsapp: t(
         STATUS_MONITORING.CHART_WHATSAPP_LABEL.key,
         STATUS_MONITORING.CHART_WHATSAPP_LABEL.value,
       ),
       hybrid: t(STATUS_MONITORING.HYBRID_LABEL.key, STATUS_MONITORING.HYBRID_LABEL.value),
     };

     return Object.entries(totals).reduce((localizedTotals, [key, value]) => {
       const localizedKey = removeInvisibleCharacters(localizedKeys[key]);
       if (localizedKey) {
         localizedTotals[localizedKey] = value;
       }
       return localizedTotals;
     }, {});
   }

   return totals;
 };

 export const getProgressPercentage = (total, data) => {
   if (total && data) {
     const totalProcessed = data.reduce(
       (acc, batch) => acc + Number(batch?.successCount || 0) + Number(batch?.failureCount || 0) + Number(batch?.unknownCount || 0),
       0,
     );
     const percentage = Math.round((totalProcessed / total) * 100);
     return percentage;
   }
   return 0;
 };

 export const isEmptyObject = obj => {
   return Object.keys(obj || {}).length === 0;
 };

export const aggregatedData = data => {
  const aggregatedData = data.reduce((acc, item) => {
    const batchNumber = item.batchNumber;

    if (!acc[batchNumber]) {
      acc[batchNumber] = {
        batchNumber,
        inQueueCount: 0,
        successCount: 0,
        failureCount: 0,
        totalCount: 0,
      };
    }

    acc[batchNumber].inQueueCount += Number(item.inQueueCount);
    acc[batchNumber].successCount += Number(item.successCount);
    acc[batchNumber].failureCount += Number(item.failureCount);
    acc[batchNumber].totalCount += Number(item.totalCount);
    acc[batchNumber].createdOn = moment(item.createdOn).format('D, MMMM  YYYY');
    acc[batchNumber].createdOnTime = moment(item.createdOn).format('LT');
    return acc;
  }, {});

  return Object.values(aggregatedData);
};

export const aggregateBatchStats = (data, activeChannel) => {
  const channel = activeChannel === 'Documents' ? 'print' : activeChannel.toLowerCase()
  return data.reduce(
    (totals, batch) => {
      if (batch.channel === channel) {
        totals.inQueueCount += Number(batch.inQueueCount);
        totals.successCount += Number(batch.successCount);
        totals.failureCount += Number(batch.failureCount);
        totals.totalCount += Number(batch.totalCount);
      }
      return totals;
    },
    { successCount: 0, inQueueCount: 0, failureCount: 0, totalCount: 0 }
  );
};

export const transformMetaSearchFilter = (inputArray, metaKeyRefs, metaValueRefs) => {
  const keyValueMap = inputArray.reduce((acc, obj) => {
    let key = obj.key;
    let value = obj.value;
    const valueDataSet = metaValueRefs[key];
    if (!valueDataSet) {
      acc[key] = acc[key] ? `${acc[key]},${value}` : value;
      return acc;
    }
    const valueSet = valueDataSet.find(val => val.key.toLowerCase() === obj.value.toLowerCase());
    const objValue = valueSet ? valueSet.value : value;
    acc[key] = acc[key] ? `${acc[key]},${objValue}` : objValue;
    return acc;
  }, {});

  return Object.entries(keyValueMap).map(([key, value]) => ({
    fieldName: metaKeyRefs[key],
    value,
  }));
};

export const transformRemovedTagFilters = (exclusionAudit, metaValueRefs, usersList = [], t) => {
  const defaultKeys = new Set(['channel', 'uniq_name', 'uniq_id', 'language', 'status']);
  const exclusionAuditData = deepCopy(exclusionAudit);

  // Map user IDs to display names for quick lookup
  const userMap = Object.fromEntries(usersList.map(({ id, displayName }) => [id, displayName]));

  const mapExclusionKeys = (exclusions) =>
    exclusions.flatMap(({ fieldName, value }) => {
      const key = defaultKeys.has(fieldName)
        ? metaSearchKeyMappings(t)[fieldName.replace(/\./g, '_')]
        : fieldName.replace(/\./g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word

      return value.split(',').map((val) => {
        const trimmedVal = val.trim();
        const valueDataSet = metaValueRefs[key]?.find((data) => data.value === trimmedVal);
        return { key, value: valueDataSet ? valueDataSet.key : trimmedVal };
      });
    });

  // Map exclusion IDs to their index for quick reference
  const exclusionIndexMap = Object.fromEntries(exclusionAudit.map(({ id }, index) => [id, index]));

  exclusionAuditData.forEach((audit) => {
    audit.doneBy = userMap[audit.doneBy] || ''; // Assign user display name

    if (audit.type === 'removed') {
      audit.exclusion = mapExclusionKeys(audit.exclusion);
      audit.isRemovedIncluded = false;
    } else if (audit.type === 'included' && audit.reference) {
      const refIndex = exclusionIndexMap[audit.reference];
      if (refIndex !== undefined) {
        audit.exclusion = mapExclusionKeys(exclusionAudit[refIndex].exclusion);
        audit.isRemovedIncluded = true;
        exclusionAuditData[refIndex].isRemovedIncluded = true;
      }
    }
  });

  return exclusionAuditData;
};

export const transformMetaSearchKeys = (searchKeys, t) => {
  const defaultKeys = ['channel', 'uniq name', 'uniq id', 'language', 'status','address'];
  const transformedKeys = searchKeys.map(key => {
    const mutatedKey = key.replace(/[_\.]/g, ' ');
    return defaultKeys.includes(mutatedKey)
      ? metaSearchKeyMappings(t)[mutatedKey.replace(/ /g, '_')]
      : mutatedKey;
  });

  const referenceKeysObject = transformedKeys.reduce((acc, transformedName, index) => {
    acc[transformedName] = searchKeys[index];
    return acc;
  }, {});
  return { transformedKeys, referenceKeysObject };
};

export const transformExclusionAndSearchKey = (data = [], type, t) => {
  return type === 'exclusions'
    ? data.map(group =>
        group.flatMap(({ fieldName, value }) =>
          (value.includes(',') ? value.split(',') : [value]).map(val => ({
            fieldName: metaSearchKeyMappings(t)[fieldName] || fieldName.replace(/[_\.]/g, ' '),
            value: val.trim(),
          })),
        ),
      )
    : type === 'search'
    ? data.flatMap(({ fieldName, value }) =>
        (value.includes(',') ? value.split(',') : [value]).map(val => ({
          fieldName: metaSearchKeyMappings(t)[fieldName] || fieldName.replace(/[_\.]/g, ' '),
          value: val.trim(),
        })),
      )
    : [];
};

export const removeInvisibleCharacters = (str) =>  str?.replace(/[\u200B-\u200D\uFEFF]/g, '');

export const formatDataForApexBarChart = (data, t, languageList, contentType, channel, batchType) => {
  if(!data.length && !languageList.length) return {barChartData:[], categories: []};
  const categories = data.map(entry => {
    const lang = languageList.find(lang => lang.value === entry.lang);
    return lang ? lang.key : '' ;
});
  const successSeries = data.map(entry => entry.success||0);
  const failureSeries = data.map(entry => entry.failure||0);

  return {
    barChartData: [
      {
          name: channel === 'email' ? (batchType === 'ADVANCED' ? removeInvisibleCharacters(t(STATUS_MONITORING.GENERATED.key, STATUS_MONITORING.GENERATED.value)) : removeInvisibleCharacters(t(STATUS_MONITORING.SENT.key, STATUS_MONITORING.SENT.value))) : removeInvisibleCharacters(t(DOCUMENT_PANEL.SUCCESS_CHART_LABEL.key, DOCUMENT_PANEL.SUCCESS_CHART_LABEL.value)),
          data: successSeries,
      },
      {
          name: removeInvisibleCharacters(t(DOCUMENT_PANEL.FAILURE_CHART_LABEL.key, DOCUMENT_PANEL.FAILURE_CHART_LABEL.value)),
          data: contentType === PrintingModal ? [0] : failureSeries,
      },
    ],
      categories: categories
  };
}

export const mergeFields = data => {
  if (data.length === 0) {
    return [];
  }
  const result = data.reduce((acc, item) => {
    let existing = acc.find(obj => obj.fieldName === item.fieldName);
    if (existing) {
      existing.value += `,${item.value}`;
    } else {
      acc.push({ ...item });
    }
    return acc;
  }, []);

  return result;
};

export const reloadTableOfContents = async (methods) => {
  try {
    let tocUUID;
    const flowUUIDs = methods.get()[COMPLEX_DOCUMENT_CONTEXT_KEYS.FLOWS];
    let tocTitleBlockUUID =null;
    for (let uuid of flowUUIDs) {
      const flowName = methods.get()[uuid]?.flowName;
      if (flowName === TABLE_OF_CONTENTS) {
        const blockUUID = methods.get()[uuid]?.[`${uuid}-0`][0];
        tocUUID = uuid;
        tocTitleBlockUUID = blockUUID;
        break;
      }
    }
    
    if (!tocUUID) {
      throw new Error('Table of Contents flow not found');
    }

    const documentId = methods.get()[COMPLEX_DOCUMENT_CONTEXT_KEYS.ID];
    const response = await getTocFlow(documentId);
    
    if (response.statusCode === 3120 && response?.data) {
      response.data.blocks[0].uuid = tocTitleBlockUUID
      methods.replaceFlow(
        { flow: response.data, uuid: tocUUID, pageId: `${tocUUID}-0` },
        false
      );
    } else {
      console.error('Error refreshing Table of Contents', response);
    }
  } catch (err) {
    console.error('Error refreshing Table of Contents:', err);
  }
};

export const handleCommunNameCheck = async (name) => {
  const payload = {
    "communicationName": name
  }
  try {
    const res = await checkCommunName(JSON.stringify(payload));
    return res?.errors?.length ? res.errors : [];
  } catch (error) {
    console.error("Error during communication name check:", error);
    return [];
  }
};

export const isTocBlock = (blockUUId, store) => {
  if (!blockUUId) return false;

  const flows = store.get()?.[COMPLEX_DOCUMENT_CONTEXT_KEYS.FLOWS] || [];

  return flows.some(flowUUID => {
    const flow = store.get()?.[flowUUID];
    const flow_blockUUID = flow?.[`${flowUUID}-0`];

    return flow_blockUUID?.[0] === blockUUId && flow?.flowName === TABLE_OF_CONTENTS;
  });
};

export const updateFunnelChartData = (funnelChart = {}, totalEmail, t) => {
  const { sent = 0, delivered = 0, opened = 0, clicked = 0 } = funnelChart;

  if (totalEmail <= 0 || sent === 0) {
    return [
      { title: `${t(
        EMAIL_DASHBOARD.FUNNEL_SECTION_SENT_LABEL.key,
        EMAIL_DASHBOARD.FUNNEL_SECTION_SENT_LABEL.value,
      )}`, count: 0, percentage: 0 },
      { title: `${t(
        EMAIL_DASHBOARD.FUNNEL_SECTION_DELIVERED_LABEL.key,
        EMAIL_DASHBOARD.FUNNEL_SECTION_DELIVERED_LABEL.value,
      )}`, count: 0, percentage: 0 },
      { title: `${t(
        EMAIL_DASHBOARD.FUNNEL_SECTION_OPENS_LABEL.key,
        EMAIL_DASHBOARD.FUNNEL_SECTION_OPENS_LABEL.value,
      )}`, count: 0, percentage: 0 },
      { title: `${t(
        EMAIL_DASHBOARD.FUNNEL_SECTION_CLICKS_LABEL.key,
        EMAIL_DASHBOARD.FUNNEL_SECTION_CLICKS_LABEL.value,
      )}`, count: 0, percentage: 0 },
    ];
  }

  const formatCount = (val) =>{
    if (val >= 1000000) {
      // more than one million
      return (val / 1000000).toFixed(1) + 'M';
    } else if (val >= 1000) {
      // more than one thousands
      return (val / 1000).toFixed(1) + 'k';
    } else {
      return val;
    }
  }

  const funnelData =  [
    { title: emailFunnelChartLabels(t).sent, count: formatCount(sent), percentage: Math.round((sent / totalEmail) * 100) || 0 },
    { title: emailFunnelChartLabels(t).delivered, count: formatCount(delivered), percentage: Math.round((delivered / sent) * 100) || 0 },
    { title: emailFunnelChartLabels(t).opened, count: formatCount(opened), percentage: Math.round((opened / delivered) * 100) || 0 },
    { title: emailFunnelChartLabels(t).clicked, count: formatCount(clicked), percentage: opened ? Math.round((clicked / opened) * 100) || 0 : 0 },
  ];

  return funnelData.map(data => ({
    ...data,
    title: removeInvisibleCharacters(data.title),
  }));
};


export const getChannelUnknownCount = (data) => {
  const unknownCount = data.reduce(
    (acc, item) => {
      const count = Number(item.unknownCount || 0);
      acc[item.channel] = (acc[item.channel] || 0) + count;
      return acc;
    },
    { print: 0, email: 0, hybrid: 0 }
  );
  return unknownCount;
};

export const getBusinessLogicByType = (data = [], type, isIdName = false) => {
  if (!type) return [];
  if (isIdName) {
    const filtered = data.filter(item => item.type === type);
    return filtered.map((data) => ({ id: data.id, name: data.name }))
  } else {
    return data.filter(item => item.type === type);
  }
};

export const buildBusinessLogicMaps = (businessLogics, currentStore) => {
  const flowBusinessLogicMap = new Map();
  const elementBusinessLogicMap = new Map();

  const flowBusinessLogicData = getBusinessLogicByType(businessLogics, 'flow');
  const elementBusinessLogicData = getBusinessLogicByType(businessLogics, 'element');

  const flows = currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.FLOWS];

  // 🔹 Helper: process a single block and update elementBusinessLogicMap
  const processBlockGroups = block => {
    if (block?.blockType !== CREATIVE_BLOCK || !block.groups?.length) return;

    block.groups.forEach(group => {
      const isBLPresent = elementBusinessLogicData.some(el =>
        el.rules[0]?.groupIDs?.includes(group.groupId),
      );

      elementBusinessLogicMap.set(group.groupId, {
        groupName: group.groupName,
        isBLPresent,
      });
    });
  };

  flows.forEach(flowUUID => {
    const flowId = currentStore[COMPLEX_DOCUMENT_CONTEXT_KEYS.PERSISTED_KEYS][flowUUID];
    const flow = currentStore[flowUUID];

    // 🔹 Flow level business logic map
    const hasBusinessLogic = flowBusinessLogicData.find(
      flowBL => flowBL.rules[0]?.flowId === flowId,
    );
    flowBusinessLogicMap.set(flowId, {blId: hasBusinessLogic?.id, isBLPresent: Boolean(hasBusinessLogic)});

    // 🔹 Process header/footer if present
    if (flow.header) processBlockGroups(currentStore[flow.header]);
    if (flow.footer) processBlockGroups(currentStore[flow.footer]);

    // 🔹 Process page blocks
    const blocks = flow[`${flowUUID}-0`] || [];
    if (blocks.length > 0)
      blocks.forEach(blockUUID => processBlockGroups(currentStore[blockUUID]));
  });
  return { flowBusinessLogicMap, elementBusinessLogicMap };
};

export const getTimeStampDetails = async (
  documentId = '',
  updateVersionStore,
  templateType = '',
  isEmail = false,
) => {
  const getProcessedTimeline = (data = []) => {
    const obj = {
      draft: null,
      qaready: null,
      qacomplete: null,
      published: null,
      rejected: null,
    };
    data.forEach(v => {
      if (v.status === COMPLEX_DOCUMENT_VERSION.DRAFT) {
        obj.draft = new Date(v.doneOn);
      } else if (v.status === COMPLEX_DOCUMENT_VERSION.QA_READY) {
        obj.qaready = new Date(v.doneOn);
      } else if (v.status === COMPLEX_DOCUMENT_VERSION.QA_COMPLETE) {
        obj.qacomplete = new Date(v.doneOn);
      } else if (v.status === COMPLEX_DOCUMENT_VERSION.REJECTED) {
        obj.rejected = new Date(v.doneOn);
      } else if (v.status === COMPLEX_DOCUMENT_VERSION.PUBLISHED) {
        obj.published = new Date(v.doneOn);
      }
    });
    return obj;
  };
  try {
    const documentTimeStampResponse = isEmail
      ? await getComplexEmailStatus(documentId, templateType)
      : await getComplexDocumentStatus(documentId, templateType);
    const responseData = documentTimeStampResponse.data;
    if ([1923, 1925, 1927, 3112].includes(responseData.statusCode)) {
      const processedTimeline = getProcessedTimeline(responseData.data);
      updateVersionStore &&
        updateVersionStore({
          [VERSION_CONTEXT_KEYS.TIMELINE_LIST]: responseData.data,
          [VERSION_CONTEXT_KEYS.LIFECYCLE_TIMELINE]: processedTimeline,
        });
    }
  } catch (e) {
    console.log(e);
  }
};

export const truncateText = (text, limit) => {
  if (typeof text !== 'string') return '';
  if (text.length <= limit) return text;
  return <span title={text}>{text.slice(0, limit) + '...'}</span>;
};

export const getSampleValue = (variableId, globalVariables) => {
  const samplevalue = globalVariables.find(list => list.id === variableId);
  if (samplevalue) {
    return samplevalue.exampleValue;
  }
  return '';
};

  export const getSampleDataSet = (variableContract, globalVariables, type, env = '', isEmail = false) => {
    let dataSet1 = { env: env };
    let dataSet = {};
    let isDynamicTableTemplate;

    const processVariableContent = (variable) => {
      const result = {};
      if (type === 'communication' || type === 'flatFile/communication' || (env === 'live' && type === 'flatFile')) {
        variable.content.forEach(contentItem => {
          if (contentItem.type === VARIABLE_TYPE.STRING) {
            result[contentItem.name] = getSampleValue(contentItem.variableId, globalVariables);
          }
          else if (contentItem.type === VARIABLE_TYPE.LIST_OF_STRINGS) {
            result[contentItem.name] = [getSampleValue(contentItem.variableId, globalVariables)];
          }
          else if (contentItem.type === VARIABLE_TYPE.CHART_OBJECT) {
            const chartObject = contentItem.content.reduce((acc, chartItem) => {
              acc[chartItem.name] = getSampleValue(chartItem.variableId, globalVariables);
              return acc;
            }, {});
            result[contentItem.name] = [chartObject];
          }
          else if (contentItem.type === VARIABLE_TYPE.OBJECT || contentItem.type === VARIABLE_TYPE.TABLE_OBJECT) {
            result[contentItem.name] = [processVariableContent(contentItem)];
          }
        });
      }
      else if (type === 'flatFile' && env === 'draft') {
        variable.variables.forEach(contentItem => {
          if (contentItem?.type.toLowerCase() === VARIABLE_TYPE.STRING) {
            result[contentItem.placeHolderText] = getSampleValue(contentItem.id, globalVariables);
          }
          else if (contentItem.type === VARIABLE_TYPE.LIST_OF_STRINGS) {
            result[contentItem.placeHolderText] = [getSampleValue(contentItem.id, globalVariables)];
          }
          else if (contentItem.type === VARIABLE_TYPE.CHART_OBJECT) {
            const chartObject = contentItem.variables.reduce((acc, chartItem) => {
              acc[chartItem.placeHolderText] = getSampleValue(chartItem.id, globalVariables);
              return acc;
            }, {});
            result[contentItem.placeHolderText] = [chartObject];
          }
          else if (contentItem.type === VARIABLE_TYPE.OBJECT || contentItem.type === VARIABLE_TYPE.TABLE_OBJECT) {
            result[contentItem.placeHolderText] = [processVariableContent(contentItem)];
          }
        });
      }
      return result;
    };

    const baseFields = { uniq_id: '', uniq_name: '' };

    const emailFields = {
      toEmailAddress: 'sample@example.com',
      cc: 'sample@example.com',
      attachmentPassword: 'password'
    };

    const isFlatFile = type.startsWith('flatFile');
    const isCommunication = type.includes('communication');

    dataSet = {
      ...(isFlatFile && { id: '' }),
      ...baseFields,
      ...(isCommunication && {
        channel: '',
        language: ''
      }),
      ...(isEmail && emailFields),
      ...dataSet
    };



    variableContract.forEach(variable => {

      if (variable.type === VARIABLE_TYPE.OBJECT || variable.type === VARIABLE_TYPE.TABLE_OBJECT) {
        const result = processVariableContent(variable);
        isDynamicTableTemplate = variable.type === VARIABLE_TYPE.TABLE_OBJECT;
        dataSet = {
          ...dataSet,
          [variable.name]: [result],
        };
      }
      else if (variable.type === VARIABLE_TYPE.CHART_OBJECT || variable.type === VARIABLE_TYPE.FORM_OBJECT) {
        let chartObject;
        if (type === 'flatFile' && env === 'draft') {
          chartObject = variable.variables.reduce((acc, contentItem) => {
            acc[contentItem.placeHolderText] = getSampleValue(contentItem.id, globalVariables);
            return acc;
          }, {});
        }
        else {
          chartObject = variable.content.reduce((acc, contentItem) => {
            acc[contentItem.name] = getSampleValue(contentItem.variableId, globalVariables);
            return acc;
          }, {});
        }
        dataSet = {
          ...dataSet,
          [variable.name]: [chartObject],
        };
      }
      else {
        const samplevalue = getSampleValue(variable.variableId, globalVariables);
        if (type === 'flatFile') {
          if (env === 'draft') {
            dataSet = {
              ...dataSet,
              [variable.placeHolderText]: samplevalue,
            };
          }
          else {
            dataSet = {
              ...dataSet,
              [variable.name]: samplevalue,
            };
          }
        }
        else {
          dataSet = {
            ...dataSet,
            [variable.name]: (variable.type === 'listOfStrings' && type !== 'flatFile/communication') ? [samplevalue] : samplevalue,
          };
        }
      }
    });

    let finalDataSet = type === 'flatFile' || type === 'flatFile/communication' ? { ...dataSet } : [{ ...dataSet1 }, { ...dataSet }]

    return finalDataSet;

  }

  export const generateCSVHeadersFromJSON = (data) => {
    const headers = [];

    Object.entries(data).forEach(([key, value]) => {

      if (!Array.isArray(value)) {
        headers.push(key);
        return;
      }

      value.forEach(obj => {
        Object.keys(obj).forEach(nestedKey => {
          if(Array.isArray(obj[nestedKey])){
             const keyName = Object.keys(obj[nestedKey][0])[0];
             nestedKey = `${key}.${keyName}`
             headers.push('table_id')             
          }          
          headers.push(`${key}$${nestedKey}`);
        });
      });
    });

    return headers;
  };

  export const downloadDelimitedFile = ({
    templateName = 'sample-file',
    headers,
    format = 'csv' | 'tsv' | 'psv',
    rows = [],
    env = ''
  }) => {
    const config = {
      csv: { delimiter: ',', extension: 'csv', mime: 'text/csv' },
      tsv: { delimiter: '\t', extension: 'txt', mime: 'text/plain' },
      psv: { delimiter: '|', extension: 'txt', mime: 'text/plain' }
    };

    const { delimiter, extension, mime } = config[format];

    const lines = [];

    if (env) {
      lines.push(`env=${env}`);
    }

    lines.push(headers.join(delimiter));

    rows.forEach(row => {
      lines.push(row.join(delimiter));
    });

    const content = lines.join('\n');

    const blob = new Blob([content], {
      type: `${mime};charset=utf-8;`
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = `${templateName}-sample.${extension}`;
    link.click();

    URL.revokeObjectURL(url);
  };

  const ALLOWED_DELIMITERS = [
    ",",
    "\t", // tab
    "|",
    "~"
  ];


  export const parseFileWithKnownDelimiters = (file) => {
    let firstRow = '';
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        delimitersToGuess: ALLOWED_DELIMITERS,
        beforeFirstChunk: (chunk) => {
          const lines = chunk
            .replace(/\r/g, '')
            .split('\n')
            .filter(Boolean);

          const potentialMetaRow = lines[0]?.trim().toLowerCase();
          if (potentialMetaRow?.startsWith('env')) {
            firstRow = lines[0];
            lines.shift();
          }
          return lines.join('\n');
        },
        complete: (results) => {
          const detectedDelimiter = results.meta.delimiter;
          if (detectedDelimiter && results.meta.fields && results.meta.fields.length > 1) {
            resolve({
              delimiter: detectedDelimiter,
              data: firstRow.length > 0 ?{env: firstRow, results: results.data} :results.data,
            });
          } else {
            reject("Could not reliably detect a multi-column delimiter.");
          }
        },
        error: (err) => {
          reject(`Parsing error: ${err.message}`);
        }
      });
    });
  };

  export const generatePayloadFromCsvFile = (rows, variables, type = '', documentId) => {

    let expectedItems = [];
    const result = [];
    const isEmail = type === 'draft/email' || type === 'live/email';
    const isCommunication = type === 'communication';
    const isDraft = type === 'draft' || type === 'draft/email';
    const usedVariables = variables;

    //To check whether all variables are present in the uploaded file
    usedVariables.forEach(item => {
      expectedItems.push(isDraft ? item.placeHolderText : item.name);
    });

    const headersFromFile = rows[0] && Object.keys(rows[0]).length > 0 ? Object.keys(rows[0]) : [];
    headersFromFile.push( ...(isEmail ? ['toEmailAddress', 'cc'] : []), ...(isCommunication ? ['channel', 'language'] : []) );
    const headers = headersFromFile.flatMap(key => key.includes('$') ? key.split('$') : key );
    const allItemsPresent = expectedItems.every(item => headers.includes(item));
    if (!allItemsPresent) {
      return result;
    }
        
    let currentGroup = null;
    const matchedVariables = [];
    let isChartBlock;
    let chartBlockVariables;
    let listVariables;
    let isListOfStrings;
    let isObjectVariable;
    let objectVariablesList=[];
    let multiLevelDynamicTableList=[];

    if (variables.length > 0) {
      const key = isDraft ? 'variables' : 'content';
      const hasMoreThanOneLevelDynamicTable = variable => variable[key]?.some(v => (v.type === VARIABLE_TYPE.TABLE_OBJECT || v.type === VARIABLE_TYPE.OBJECT) && Array.isArray(v[key]) && v[key].length > 0 );
      variables.forEach(variable => {
        if ((variable.type === VARIABLE_TYPE.OBJECT || variable.type === VARIABLE_TYPE.TABLE_OBJECT) &&
          Array.isArray(variable[key]) && variable[key].length > 0) {
          (hasMoreThanOneLevelDynamicTable(variable) ? multiLevelDynamicTableList : objectVariablesList).push(variable);
        }
      });
      chartBlockVariables = variables.filter(v => v.type === VARIABLE_TYPE.CHART_OBJECT && Array.isArray(v[key]) && v[key].length > 0);
      listVariables = variables.filter(v => v.type === VARIABLE_TYPE.LIST_OF_STRINGS || v.type === 'ListString');
    }

    rows.forEach(row => {
      if (row.id !== currentGroup?.id) {
        const hasValidId = row.id && row.id.trim() !== '';
        const keys = Object.keys(row);
        if (hasValidId) {
          const baseDataSet = {
            id: row.id,
            uniq_id: row.uniq_id || null,
            uniq_name: row.uniq_name || null,
          };
          const baseGroup = {
            dataSet: baseDataSet,
            tagInfo: [],
          };
          currentGroup = {
            ...baseGroup,
            ...(isEmail && {
              mailTemplateId: documentId,
              to: row.toEmailAddress ? [row.toEmailAddress] : null,
              cc: row.cc ? [row.cc] : null,
              attachmentPassword: row.attachmentPassword || null,
            }),
            ...(isCommunication && {
              communicationId: documentId,
              to: row.toEmailAddress ? [row.toEmailAddress] : null,
              cc: row.cc ? [row.cc] : null,
              language: row.language || null,
              channel: row.channel || null,
              attachmentPassword: row.attachmentPassword || null,
            }),
            ...(!isEmail && !isCommunication && {
              documentId,
            }),
          };
          result.push(currentGroup);
        }
        if(variables?.length > 0){
        Object.keys(row).forEach(key => {
          if (key.startsWith('Tag') && row[key]) {
            currentGroup.tagInfo.push({
              tagName: key,
              tagValue: row[key]
            });
          }
          const splitKey = key.split('$');
          if (row[key] !== '' && objectVariablesList.length > 0 && objectVariablesList.some(item => item.name === splitKey[0])) {
            const [blockName, fullPath] = key.split('$');
            if (['id', 'uniq_id', 'uniq_name'].includes(blockName)) return;
            if (!currentGroup.dataSet[blockName]) {
              currentGroup.dataSet[blockName] = [];
            }
            let targetObj = currentGroup.dataSet[blockName].at(-1);
            if (!targetObj || targetObj.hasOwnProperty(fullPath)) {
              targetObj = {};
              currentGroup.dataSet[blockName].push(targetObj);
            }
            targetObj[fullPath] = row[key];
          }
          else if ( row[key] !== '' &&  chartBlockVariables.length > 0 && chartBlockVariables.some(item => item.name === splitKey[0]) ) {
            const matchedChartBlockVariables = chartBlockVariables.filter(item => item.name === splitKey[0]);
            matchedChartBlockVariables.forEach(parentVar => {
              const children = isDraft ? parentVar.variables : parentVar.content;
              const childKey = isDraft ? 'placeHolderText' : 'name';
              const parentKey = isDraft ? parentVar.placeHolderText : parentVar.name;
              children.forEach(v => {
                const identifier = v[childKey];
                if (key === `${parentKey}$${identifier}`) {
                  if (!currentGroup.dataSet[parentKey]) {
                    currentGroup.dataSet[parentKey] = [];
                  }
                  let targetObj = currentGroup.dataSet[parentKey][currentGroup.dataSet[parentKey].length - 1];
                  if (!targetObj || targetObj[identifier]) {
                    targetObj = {};
                    currentGroup.dataSet[parentKey].push(targetObj);
                  }
                  targetObj[identifier] = row[key];
                }
              });
            });
          }
          else if (row[key] !== '' && multiLevelDynamicTableList.length > 0 && multiLevelDynamicTableList.some(item => item.name === splitKey[0])) {
            multiLevelDynamicTableList.forEach(parentVar => {
              const parentKey = isDraft ? parentVar.placeHolderText : parentVar.name;
              if (!key.startsWith(`${parentKey}$`)) return;
              const tableId = row.table_id?.trim();
              if (!tableId) return;
              const cellValue = row[key];
              if (!cellValue || !String(cellValue).trim()) return;
              const [, fullPath] = key.split('$');
              const childPath = fullPath.replace(`${parentKey}.`, '');
              const groupKey = childPath.includes('.') ? childPath.split('.')[0] : null;
              if (!currentGroup.dataSet[parentKey]) {
                currentGroup.dataSet[parentKey] = [];
              }
              let tableObj = currentGroup.dataSet[parentKey]
                .find(t => t.table_id === tableId);
              if (!tableObj) {
                tableObj = { table_id: tableId };
                currentGroup.dataSet[parentKey].push(tableObj);
              }
              if (groupKey) {
                if (!tableObj[groupKey]) {
                  tableObj[groupKey] = [];
                }
                tableObj[groupKey].push({
                  [childPath]: cellValue
                });
              }
              else {
                const fullKey = `${parentKey}.${childPath}`;
                if (!tableObj[fullKey]) {
                  tableObj[fullKey] = cellValue;
                }
              }
            });
          }         
          else if (row[key] !== '' && listVariables.length > 0 && listVariables.some(item => (item.placeHolderText === splitKey[0] || item.name === splitKey[0]))) {
            listVariables.forEach(parentVar => {
              const varName = isDraft ? parentVar.placeHolderText : parentVar.name;
              if (key.includes(varName)) {
                if (!currentGroup.dataSet[varName]) {
                  currentGroup.dataSet[varName] = [];
                }
                const values = String(row[key]).split(',').map(v => v.trim()).filter(Boolean);
                currentGroup.dataSet[varName].push(...values);
                matchedVariables[varName] = values;
              }
            });
          }
          else {
            if (row[key] !== '') {
              variables.forEach(parentVar => {
                const parentKey = isDraft ? parentVar.placeHolderText : parentVar.name;
                if (key.includes(parentKey)) {
                  currentGroup.dataSet[parentKey] = row[key];
                  matchedVariables[parentKey] = row[key];
                }
              });
            }
          }
        });
      }
      }
    });

    return result;
  }

  export const base64ToPdfBlob = base64 => {
    const cleanedBase64 = base64.includes(',') ? base64.split(',')[1] : base64;
  
    const byteCharacters = atob(cleanedBase64);
    const byteNumbers = new Array(byteCharacters.length);
  
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
  
    const byteArray = new Uint8Array(byteNumbers);
  
    return new Blob([byteArray], { type: 'application/pdf' });
  };

export function extractUnsupportedCharacters(description) {
  if (!description) return '';

  const match = description.match(/\[(.*?)\]/);
  return match ? match[1] : '';
}

export const strictEncode = (value) =>
  encodeURIComponent(value).replace(/[-_()]/g, c =>
    '%' + c.charCodeAt(0).toString(16).toUpperCase()
  );
  export const buildQueryParams = payload => {
    const params = new URLSearchParams();
  
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params.append(key, value);
      }
    });
  
    return params.toString();
  };
  
export const isFeatureEnabled = (feature, userDetails) => {
  if(!userDetails.features || userDetails.features.length === 0) return true;
  const targetFeature = userDetails.features.find(feat => feat.name.toLowerCase() === feature.toLowerCase());
  return targetFeature?.isEnabled || false;
}

export const sanitizeFontSize = (value = '') => {
  // keep only digits and dot
  let v = value.replace(/[^0-9.]/g, '');

  // allow only one dot
  const parts = v.split('.');
  if (parts.length > 2) {
    v = parts[0] + '.' + parts.slice(1).join('');
  }

  const [intPart = '', decPart = ''] = v.split('.');

  // max 3 digits before decimal
  const safeInt = intPart.slice(0, 3);

  // max 2 digits after decimal
  const safeDec = decPart.slice(0, 2);

  // rebuild value
  return decPart !== undefined && v.includes('.')
    ? `${safeInt}.${safeDec}`
    : safeInt;
};


export const generateSampleExcelforBatch = (template, isMailRoomModuleEnabled, tagsData) => {
    const { variableContract } = template;
    // Determine repeated blocks and chart blocks locally
    let isRepeatedBlocks = false;
    let isChartBlock = false;
    if (variableContract && variableContract.length > 0) {
        isRepeatedBlocks = variableContract.some(variable => variable.type === VARIABLE_TYPE.OBJECT);
        isChartBlock = variableContract.some(variable => variable.type === VARIABLE_TYPE.CHART_OBJECT);
    }

    const { isNestedTable } = dynamicTableHasMoreThanTwoLevels(variableContract);
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet([]);

    // Add data to worksheet
    let col = 0;
    if (isRepeatedBlocks || isChartBlock) {
        XLSX.utils.sheet_add_aoa(ws, [['id']], {
            origin: { r: 0, c: col++ },
        });
    }
    XLSX.utils.sheet_add_aoa(ws, [['uniq_id']], {
        origin: { r: 0, c: col++ },
    });
    XLSX.utils.sheet_add_aoa(ws, [['uniq_name']], {
        origin: { r: 0, c: col++ },
    });

    // Add main headers and subheaders
    variableContract.forEach(item => {
        if (
            item.type === VARIABLE_TYPE.STRING_TITLE_CASE ||
            item.type === VARIABLE_TYPE.STRING ||
            item.type === VARIABLE_TYPE.LIST_OF_STRINGS ||
            item.type === VARIABLE_TYPE.DATE.toLowerCase() ||
            item.type === VARIABLE_TYPE.HTML
        ) {
            XLSX.utils.sheet_add_aoa(ws, [[item.name]], {
                origin: { r: 0, c: col },
            });
            col++;
        } else if (item.type === VARIABLE_TYPE.OBJECT || item.type === VARIABLE_TYPE.CHART_OBJECT) {
            const addCell = (row, value) => {
                XLSX.utils.sheet_add_aoa(ws, [[value]], { origin: { r: row, c: col } });
            };

            item.content.forEach(subItem => {
                let isRepeatedBlocksInternal = false;
                let isChartBlockInternal = false;
                if (variableContract && variableContract.length > 0) {
                    isRepeatedBlocksInternal = variableContract.some(
                        variable => variable.type === VARIABLE_TYPE.OBJECT && variable.content.length > 0,
                    );
                    isChartBlockInternal = variableContract.some(variable =>
                        variable.content?.some(
                            v => v.type === VARIABLE_TYPE.CHART_OBJECT && v.content.length > 0,
                        ),
                    );
                }

                if (subItem?.content && (isNestedTable || isRepeatedBlocksInternal || isChartBlockInternal)) {
                    if (item.type === VARIABLE_TYPE.OBJECT || item.type === VARIABLE_TYPE.TABLE_OBJECT) {
                        addCell(0, item.name);
                        addCell(1, `table_id`);
                        col++;
                    }

                    if (isRepeatedBlocksInternal) {
                        subItem.content.forEach(innerChild => {
                            addCell(0, item.name);
                            if (isChartBlockInternal && subItem.type === VARIABLE_TYPE.CHART_OBJECT) {
                                addCell(1, `${subItem.name}.${innerChild.name}`);
                            } else {
                                addCell(1, `${item.name}.${innerChild.name}`);
                            }
                            col++;
                        });
                    } else {
                        subItem.content.forEach(innerChild => {
                            addCell(0, item.name);
                            addCell(
                                1,
                                item.type === VARIABLE_TYPE.OBJECT
                                    ? innerChild.name
                                    : `${item.name}.${innerChild.name}`,
                            );
                            col++;
                        });
                    }
                } else {
                    addCell(0, item.name);
                    addCell(1, subItem.name);
                    col++;
                }
            });
        }
    });
    if (isMailRoomModuleEnabled && tagsData) {
        const tags = tagsData.map(item => item.tagName);
        XLSX.utils.sheet_add_aoa(ws, [['printable', ...tags]], {
            origin: { r: 0, c: col++ },
        });
    }
    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Generate Excel file
    XLSX.writeFile(wb, `${template.name}.xlsx`);
};

export const getFlatFilesPayload = async (file, template,type = '') => {
    const { data, delimiter } = await parseFileWithKnownDelimiters(file);
    const payload = generatePayloadFromCsvFile(
        data,
        template.variableContract,
        type ? type : 'live',
        template?.id,
    );
    if(payload.length === 0){
       message.error('The uploaded file is not valid. Please upload a valid file')
    }
    return payload;
};

export const downloadFlatFilesForBatch = (format, template, globalVariables, t = dummyCallback) => {
    if (template?.variableContract.length > 0) {
        const { hasMoreThanTwoLevels } = dynamicTableHasMoreThanTwoLevels(template.variableContract);
        if (hasMoreThanTwoLevels) {
            message.warning(
                t(
                    TRANSACTIONS.WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD.key,
                    TRANSACTIONS.WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD.value,
                ),
            );
            return;
        }
    }
    const dataset = getSampleDataSet(
        template.variableContract,
        globalVariables,
        'flatFile',
        'live',
        false,
    );
    const headers = generateCSVHeadersFromJSON(dataset);
    const templateName = template['name'];
    downloadDelimitedFile({ templateName, headers, format: format });
    return;
};

export const downloadJsonForBatch = (format, template, globalVariables, isMailRoomModuleEnabled, tagsData) => {
    let dataSet = {};
    template.variableContract.forEach(variable => {
        dataSet = {
            ...dataSet,
            uniq_id: '',
            uniq_name: '',
        };
        if (variable.type === VARIABLE_TYPE.OBJECT) {
            const result = {};

            variable.content.forEach(contentItem => {
                if (contentItem.type === VARIABLE_TYPE.CHART_OBJECT) {
                    const chartObject = contentItem.content.reduce((acc, contentItem) => {
                        acc[contentItem.name] = getSampleValue(contentItem.variableId, globalVariables);
                        return acc;
                    }, {});

                    result[contentItem.name] = [chartObject];
                } else {
                    variable.content.forEach(nonChartContentItem => {
                        result[nonChartContentItem.name] =
                            nonChartContentItem.type === VARIABLE_TYPE.STRING
                                ? getSampleValue(nonChartContentItem.variableId, globalVariables)
                                : nonChartContentItem.type === VARIABLE_TYPE.CHART_OBJECT ||
                                    nonChartContentItem.type === VARIABLE_TYPE.OBJECT
                                    ? [
                                        {
                                            [nonChartContentItem.content[0].name]:
                                                nonChartContentItem.type === VARIABLE_TYPE.LIST_OF_STRINGS
                                                    ? [getSampleValue(nonChartContentItem.content[0]?.variableId, globalVariables)]
                                                    : getSampleValue(nonChartContentItem.content[0]?.variableId, globalVariables),
                                        },
                                    ]
                                    : [
                                        {
                                            [nonChartContentItem.content[0].name]: getSampleValue(
                                                nonChartContentItem.content[0]?.variableId,
                                                globalVariables
                                            ),
                                        },
                                    ];
                    });
                }
            });

            dataSet = {
                ...dataSet,
                [variable.name]: [result],
            };
        } else if (
            variable.type === VARIABLE_TYPE.CHART_OBJECT ||
            variable.type === VARIABLE_TYPE.FORM_OBJECT
        ) {
            const chartObject = variable.content.reduce((acc, contentItem) => {
                acc[contentItem.name] = getSampleValue(contentItem.variableId, globalVariables);
                return acc;
            }, {});

            dataSet = {
                ...dataSet,
                [variable.name]: [chartObject],
            };
        } else {
            const samplevalue = getSampleValue(variable.variableId, globalVariables);
            dataSet = {
                ...dataSet,
                [variable.name]: variable.type === 'listOfStrings' ? [samplevalue] : samplevalue,
            };
        }
    });

    if (isMailRoomModuleEnabled && tagsData) {
        const tags = tagsData.map(item => item.tagName);
        tags.forEach(key => {
            dataSet[key.replace(/\s+/g, '_')] = '';
        });
        dataSet.printable = false;
    }
    if (format === 'JSON') {
        jsonToFile([dataSet], `${template['name']}-sample-request`);
    } else if (format === 'XML') {
        const xmlString = getXMLFromJSON({ request: [dataSet] });
        xmlToFile(xmlString, `${template['name']}-sample-request`);
    }
};

export const beforeUploadBatch = async (
    setRequestData,
    setUploadedFile,
    file,
    template,
    isMailRoomModuleEnabled,
    tagsData,
    jobName,
    t = dummyCallback
) => {
    let requests;
    if (file) {
        const fileFormat = checkFileFormat(file.name) ? 'excel' : file.type;
        if (fileFormat === 'text/plain' || fileFormat === 'text/csv') {
            requests = await getFlatFilesPayload(file, template);
            if(requests && requests.length > 0){
            setRequestData(requests);
            setUploadedFile(file);
            }
        }
    }
    const reader = new FileReader();
    reader.onload = async event => {
        const binaryString = event.target.result;
        requests = await getPayloadFromFile(
            binaryString,
            file,
            template,
            t,
            false,
            isMailRoomModuleEnabled,
            tagsData,
            false,
            true
        );
      if(requests && requests.length > 0){
          setUploadedFile(file);
          setRequestData(requests);
      }
    };
    reader.readAsBinaryString(file);
    return false; // Prevent default upload behavior
};

///Email batch helper 
const getBlockTypes = (selectedTemplate) => {
    if (selectedTemplate?.variableContract?.length > 0) {
        const isRepeatedBlocks = selectedTemplate?.variableContract?.some(
            variable => variable.type === VARIABLE_TYPE.OBJECT,
        );
        const isChartBlock = selectedTemplate?.variableContract?.some(
            variable => variable.type === VARIABLE_TYPE.CHART_OBJECT,
        );
        return { isRepeatedBlocks, isChartBlock };
    }
    return { isRepeatedBlocks: false, isChartBlock: false };
};

export const apiArrayToExcelforBatch = async (selectedTemplate) => {
    const { isRepeatedBlocks, isChartBlock } = getBlockTypes(selectedTemplate);
    const wb = XLSX.utils.book_new();
    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet([]);
    // Add data to worksheet
    let col = 0;
    if (isRepeatedBlocks || isChartBlock) {
        XLSX.utils.sheet_add_aoa(ws, [['id']], {
            origin: { r: 0, c: col++ },
        });
    }
    XLSX.utils.sheet_add_aoa(ws, [['uniq_id']], {
        origin: { r: 0, c: col++ },
    });
    XLSX.utils.sheet_add_aoa(ws, [['uniq_name']], {
        origin: { r: 0, c: col++ },
    });
    const header = ['To Email Address', 'CC'];
    if (selectedTemplate?.passwordProtected ?? false) {
        header.push('Attachment Password');
    }
    header.forEach(item => {
        XLSX.utils.sheet_add_aoa(ws, [[item]], {
            origin: { r: 0, c: col },
        });
        col++;
    });
    // Add main headers and subheaders
    for (const item of selectedTemplate?.variableContract ?? []) {
        if (
            item.type.toLowerCase() === VARIABLE_TYPE.STRING ||
            item.type === VARIABLE_TYPE.LIST_OF_STRINGS ||
            item.type === 'date' || item.type === VARIABLE_TYPE.HTML
        ) {
            XLSX.utils.sheet_add_aoa(ws, [[item.name]], {
                origin: { r: 0, c: col },
            });
            col++;
        } else if (item.type === VARIABLE_TYPE.OBJECT || item.type === VARIABLE_TYPE.CHART_OBJECT) {
            item.content.forEach(subItem => {
                XLSX.utils.sheet_add_aoa(ws, [[item.name]], {
                    origin: { r: 0, c: col },
                });
                XLSX.utils.sheet_add_aoa(ws, [[subItem.name]], {
                    origin: { r: 1, c: col },
                });

                col++;
            });
        }
    }
    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    // Generate Excel file
    XLSX.writeFile(wb, `${selectedTemplate?.name}.xlsx`);
    return;
};

export const beforeUploadEmailTransactionBatch = async (setRequestData,setUploadedFile,isMailRoomModuleEnabled,file, selectedTemplate, jobName, t = dummyCallback) => {
    if (file) {
        const fileFormat = checkFileFormat(file.name) ? 'excel' : file.type;
        if (fileFormat === 'text/plain' || fileFormat === 'text/csv') {
            const payload = await getFlatFilesPayload(file, selectedTemplate,'live/email');
            if(payload && payload.length > 0){
              setRequestData(payload);
              setUploadedFile(file);
            }
        }
    }
    const reader = new FileReader();
    reader.onload = async event => {
        const binaryString = event.target.result;
        const requests = getPayloadFromFile(binaryString, file, selectedTemplate, t, true, isMailRoomModuleEnabled,undefined,false,true);
          if(requests && requests.length > 0){
              setRequestData(requests);
              setUploadedFile(file);
            }
    };
    reader.readAsBinaryString(file);
    return false; // Prevent default upload behavior
};

export const downloadSampleFormatForBatch = (format, selectedTemplate, globalVariables) => {
    let dataSet = {};
   selectedTemplate?.variableContract && selectedTemplate.variableContract.forEach(variable => {
        dataSet = {
            ...dataSet,
            uniq_id: '',
            uniq_name: ''
        };
        if (variable.type === VARIABLE_TYPE.OBJECT) {
            const result = {};

            variable.content.forEach(contentItem => {
                if (contentItem.type === VARIABLE_TYPE.CHART_OBJECT) {
                    const chartObject = contentItem.content.reduce((acc, contentItem) => {
                        acc[contentItem.name] = getSampleValue(contentItem.variableId, globalVariables);
                        return acc;
                    }, {});

                    result[contentItem.name] = [chartObject];
                } else {
                    variable.content.forEach(nonChartContentItem => {
                        result[nonChartContentItem.name] = getSampleValue(nonChartContentItem.variableId, globalVariables) || [
                            {},
                        ];
                    });
                }
            });

            dataSet = {
                ...dataSet,
                [variable.name]: [result],
            };
        } else if (variable.type === VARIABLE_TYPE.CHART_OBJECT) {
            const chartObject = variable.content.reduce((acc, contentItem) => {
                acc[contentItem.name] = getSampleValue(contentItem.variableId, globalVariables);
                return acc;
            }, {});

            dataSet = {
                ...dataSet,
                [variable.name]: [chartObject],
            };
        } else {
            const samplevalue = getSampleValue(variable.variableId, globalVariables);
            dataSet = {
                ...dataSet,
                [variable.name]: variable.type === 'listOfStrings' ? [samplevalue] : samplevalue,
            };
        }
    });

    const sampleJSON = [
        {
            ...dataSet,
            toEmailAddress: 'sample@example.com',
            cc: 'sample@example.com',
            attachmentPassword: 'password',
        },
    ];
    if (format === 'JSON') {
        jsonToFile(sampleJSON, `${selectedTemplate['name']}-sample-request`);
    } else if (format === 'XML') {
        const xmlString = getXMLFromJSON({ request: sampleJSON });
        xmlToFile(xmlString, `${selectedTemplate['name']}-sample-request`);
    }
};

export const downloadFlatFilesForEmailBatch = (format, selectedTemplate, globalVariables, t) => {
    if (selectedTemplate?.variableContract.length > 0) {
        const { hasMoreThanTwoLevels } = dynamicTableHasMoreThanTwoLevels(selectedTemplate.variableContract);
        if (hasMoreThanTwoLevels) {
            message.warning(t(
                TRANSACTIONS.WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD.key,
                TRANSACTIONS.WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD.value,
            ));
            return;
        }
    }
    const dataset = getSampleDataSet(selectedTemplate.variableContract, globalVariables, 'flatFile', 'live', true);
    const headers = generateCSVHeadersFromJSON(dataset);
    const templateName = selectedTemplate['name'];
    downloadDelimitedFile({ templateName, headers, format: format });
    return;
};

export const downloadSampleFileForBatch = (dataset = {}, response, fileFormat, delimiter = '', env, t = dummyCallback) => {
    const effectiveFormat = fileFormat === 'TXT' ? delimiter : fileFormat;
    switch (effectiveFormat) {
        case 'excel':
            const variableContract = {
                variableContract: response.variableContract,
                passwordProtected: response.passwordProtected,
                name: `${response?.communicationName}-sample`,
                env: env
            };
            generateSampleExcelforBatch(variableContract, false, false, undefined, true, t);
            break;
        case 'json':
            jsonToFile(dataset, `${response?.communicationName}-sample`);
            break;
        case 'xml':
            const req = { request: dataset };
            const xmlString = getXMLFromJSON({ requests: req }, {}, true);
            xmlToFile(xmlString, `${response?.communicationName}-sample`);
            break;
        case 'csv':
        case 'tsv':
        case 'psv':
            const headers = generateCSVHeadersFromJSON(dataset);
            const templateName = `${response?.communicationName}`;
            downloadDelimitedFile({ templateName, headers, format: effectiveFormat, rows: [], env: env });
            break;
        default:
            break;
    }
};

export const getFlatFilesPayloadCommunication = async (data, templateVariables, communicationId) => {
  const payload = generatePayloadFromCsvFile(data, templateVariables, 'communication', communicationId);
  return payload;
}

export const onImportFileHelper = async (setEnvValue,setRequestData,setUploadedFile,
  file,
  templateDetails,
  jobName,
  selectedTemplate,
  t = dummyCallback
) => {
  let result = [];
  if (file) {
    const fileFormat = checkFileFormat(file.name) ? 'excel' : file.type;
    if (fileFormat === 'text/plain' || fileFormat === 'text/csv') {
      const { data, delimiter } = await parseFileWithKnownDelimiters(file);
      if (!data.env) {
        message.error(t(
          trans.INVALID_ENV.key,
          trans.INVALID_ENV.value,
        ));
        return;
      }
      const envFromFile = fileFormat === 'text/csv' ? data?.env?.split(',').map(v => v.trim()).filter(Boolean)[0] : data?.env;
      const envValue = envFromFile.split('=');
      const templateVariables = templateDetails.variableContract;
      const payload = await getFlatFilesPayloadCommunication(data?.results, templateVariables, templateDetails.communicationId);
      if (payload.length === 0) {
        message.error('The uploaded file is not valid. Please upload a valid file');
        return;
      }
      if (payload && payload.length > 0) {
        const env = envValue.length > 0 ? envValue[1] : '';
        setEnvValue(env);
        setRequestData(payload);
        setUploadedFile(file);
      }
      return;
    }
  }

   const reader = new FileReader();
      reader.onload = async event => {
        const binaryString = event.target.result;
        const fileFormat = checkFileFormat(file.name) ? 'excel' : file.type
        const { envType } = processFile(fileFormat, binaryString,t);      
        if (!envs.includes(envType)) {
          message.error('Please provide a valid environment value');
          return;
        }
        const payload = getPayloadFromFile(binaryString, file, templateDetails, t, false, false, undefined, true, true);
        if (payload && payload.length > 0) {
          const envData = envType? envType:'';
          setEnvValue(envData);
          setRequestData(payload);
          setUploadedFile(file);
        }     
      }
    if (file.type === 'application/json' || file.type === 'application/xml' || file.type === 'text/xml') {
        reader.readAsText(file);
      } else {
        reader.readAsBinaryString(file);
      }
      // e.target.value = '';

  return result;
};

export const getHybridPayloadStatusKeyMap = {
    'Generated':'GENERATED',
    'Approved':'APPROVED',
    'Hold':'HOLD',
    'Release':'RELEASE',
    'Generation failed':'GENERATION_FAILED',
    'Yet to be generated':'GENERATION_NOT_STARTED',
}

